const CACHE_KEY = 'mh-hero-video-id';

export function readCachedHeroVideoId() {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached && /^[a-zA-Z0-9_-]{11}$/.test(cached)) {
      return cached;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function writeCachedHeroVideoId(videoId) {
  if (!videoId) return;
  try {
    sessionStorage.setItem(CACHE_KEY, videoId);
  } catch {
    /* ignore */
  }
}

export function clearCachedHeroVideoId() {
  try {
    sessionStorage.removeItem(CACHE_KEY);
  } catch {
    /* ignore */
  }
}
